import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        margin: 0,
        padding: '0 0 20px 0',
        textAlign: 'left',
    },
    signInLink: {
        ...theme.typographyPresets.bodySecondaryLight,
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        cursor: 'pointer',
        textDecoration: 'underline',
        border: 0,
        background: 0,
    },
    paywallHeading: {
        fontFamily: theme.typographyPresets.fonts.notoSans.bold,
        fontStyle: 'normal',
        marginBottom: 14,
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',

        '& span': {
            fontWeight: 'bold',
            textTransform: 'uppercase',
            fontSize: 14,
        },

        '& a': {
            textDecoration: 'underline',
            fontSize: 12,
            fontFamily: theme.typographyPresets.fonts.notoSans.regular,
            lineHeight: 1.65,
            color: theme.colors.brand.blue,
            transition: 'color .2s ease-in-out',

            '&:hover': {
                color: theme.colors.text.dark,
            },
        },
    },
    authForm: {
        marginTop: 24,
    },
    '@media (min-width: 768px)': {
        signInLink: {
            fontSize: 12,
        },
    },
    paragraph: {
        ...theme.typographyPresets.bodyTertiary,
    },
    signUpButton: {
        marginBottom: 32,
    },
    message: {
        ...theme.typographyPresets.bodySecondary,
        margin: ' 16px 0 32px 0',
        textAlign: 'center',
        width: '100%',
    },
}))
